import eventbus from 'tiny-emitter/instance';

export default class EditSection {
  constructor(app, section) {
    this.app = app;
    this.canvas = this.app.canvas;
    this.svg = this.app.svg;
    this.section = section;
    this.setup();
    return this;
  }

  setup() {
    this.prepareCanvas();
    this.prepareSection();
    this.centerizeAndZoom();
  }

  prepareCanvas() {
    eventbus.emit('grid:hide');
    eventbus.emit('selection:cleared');
    eventbus.emit('seatmap:hide:sections', this.section);
  }

  prepareSection() {
    this.section.inside();
  }

  centerizeAndZoom() {
    // eventbus.emit('camera:zoom', ZOOM.LEVELS.INSIDESECTION, false);
    // const { w, h } = this.section.rbox();
    // eventbus.emit('camera:zoom:fit', w, h);
    // const { cx, cy } = this.section.rbox();
    // eventbus.emit('camera:pan', cx, cy);

    this.app.zoomManager.saveZoom();
    this.app.zoomManager.zoomAndCenterBox(this.section.rbox(this.app.canvas));
  }

  destroy() {
    this.section.outside();
    eventbus.emit('grid:show');
    eventbus.emit('seatmap:show:sections');
    eventbus.emit('selection:cleared');
    this.app.zoomManager.restoreZoom();
  }
}
